<template>
  <q-select
    :value="value"
    :options="options"
    @change="$emit('input', $event)"
  />
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        required: true
      }
    },

    computed: {
      options () {
        return ['never', 'monthly', 'yearly'].map(interval => {
          return {
            label: this.$i18n.t(`reset_${interval}`),
            value: interval
          }
        })
      }
    }
  }
</script>

<style>

</style>
